import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DuplicateDetectedDialog } from '@core/models/leave-admin/employees/duplicate-detected-dialog.model';
import { LayoutService } from '@core/services';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { Subject, Observable } from 'rxjs';

@Component({
    selector: 'app-duplicate-detected-dialog',
    templateUrl: './duplicate-detected-dialog.component.html',
    styleUrls: ['./duplicate-detected-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DuplicateDetectedDialogComponent implements OnInit {
  static readonly componentName = 'DuplicateDetectedDialogComponent';
  
  public isSubmitting$: Subject<boolean> = new Subject<boolean>();

  public position = position;
  public onDragEnded = onDragEnded;

  public isMobile$: Observable<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { 
      sysText: any,
      duplicateDetectedDialog: DuplicateDetectedDialog
      },
    private layoutService: LayoutService,
    private dialogRef: MatDialogRef<DuplicateDetectedDialogComponent>
  ) { }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();
  }
}
